import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { OriginSsoService } from "../services/origin-sso.service";

@Injectable({
   providedIn: "root"
})
export class OriginSsoGuard implements CanActivate {
   private originSsoService = inject(OriginSsoService);

   public canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
   ): boolean {
      return this.originSsoService.isAuthenticated;
   }
}
